import * as React from "react"

const SvgConsentOneBEnd = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 967 1080"
  >
    <defs>
      <pattern
        id="New_Pattern_Swatch_3"
        data-name="New Pattern Swatch 3"
        width={131}
        height={104}
        patternTransform="translate(-1806 -1576)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect width={131} height={104} fill="none" />
        <rect width={131} height={104} fill="#fbaa2c" />
      </pattern>
      <pattern
        id="New_Pattern_Swatch_3-3"
        data-name="New Pattern Swatch 3"
        width={131}
        height={104}
        patternTransform="translate(-1845 -1508)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect width={131} height={104} fill="none" />
        <rect width={131} height={104} fill="#fbaa2c" />
      </pattern>
      <pattern
        id="New_Pattern_Swatch_4"
        data-name="New Pattern Swatch 4"
        width={131}
        height={104}
        patternTransform="translate(-1845 -1508)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect width={131} height={104} fill="none" />
        <rect width={131} height={104} fill="#13a89e" />
      </pattern>
      <pattern
        id="New_Pattern_Swatch_2"
        data-name="New Pattern Swatch 2"
        width={131}
        height={104}
        patternTransform="translate(-1845 -1508)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect width={131} height={104} fill="none" />
        <rect width={131} height={104} fill="#a2ce46" />
      </pattern>
      <pattern
        id="New_Pattern_Swatch_3-11"
        data-name="New Pattern Swatch 3"
        width={131}
        height={104}
        patternTransform="translate(-93 -2072)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect width={131} height={104} fill="none" />
        <rect width={131} height={104} fill="#fbaa2c" />
      </pattern>
      <clipPath id="clip-path">
        <path
          d="M339.48,786a108.38,108.38,0,0,1,33.74,3c17,4.35,41.8-8.21,41.8-8.21-6.38-17.72-8.16-114.77-27.43-143l-16.47,2.29-16.47-2.34c-4.84,11.17-10.79,35.82-7.21,62.64C354.65,754.36,339.48,786,339.48,786Z"
          fill="#fff"
        />
      </clipPath>
      <linearGradient
        id="linear-gradient"
        x1={8782.71}
        y1={41.69}
        x2={8275.39}
        y2={907.12}
        gradientTransform="matrix(-1, 0, 0, 1, 9027.61, 0)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#f9db87" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
    </defs>
    <g
      style={{
        isolation: "isolate",
      }}
    >
      <g id="Layer_15" data-name="Layer 15">
        <path
          d="M453.59,531.52c132.77,35.93,234-39.46,299.83-115.41,57.75-66.59,76.32-152.91,89.9-240C857.59,84.52,900.32,40.5,961,1.67V0H0V813.41C14.93,785.91,196.91,462.06,453.59,531.52Z"
          fill="#351377"
        />
        <path d="M239.83,560.13c62.74-34,135.56-50.6,215.65-28.92,48.95,13.24,93.61,11.34,133.78-.12V456.67a5.92,5.92,0,0,0-5.92-5.92H542.06V382.83H303V449l-15.88.15H244.88c-3.34,0-6,2.71-5,6.06Z" />
      </g>
      <g id="DJ">
        <path
          d="M492.72,290.44c20.64-18.23,15.21-74.07,16.79-81.28,1.5-6.86,7.07-8.09,9.73-17.87.52-1.92.88-4-.15-6-1.21-2.25-4.23-4.86-7.39-3.38-3.43,1.6-6,12-7.28,11.77-1.11-.19-.13-8.47-1.71-8.78-2.12-.41-3.88,5.51-4.61,12.17a42.49,42.49,0,0,0-.21,9.72c.67,11.77-11,47.94-12.19,53.55Z"
          fill="#efc1ab"
        />
        <path
          d="M438.48,229.52c7.94,1.33,13.87,1.6,19.23,5,10.3,6.6,28,25.83,28,25.83L504,270.65S497.62,298.85,482,304c-9.17,3-18.17-12.35-18.17-12.35L467,344.16H380.93l4.76-51.47c-7.88-18.41-20.52-49.31-6-58,6.93-4.18,20.11-5.76,20.11-5.76Z"
          fill="#9f4da3"
        />
        <path
          d="M408.36,210v12.45a3.52,3.52,0,0,1-1.51,2.9,41.36,41.36,0,0,1-7.07,3.51s11.93,3.13,19,3.13c8.43,0,19.73-2.5,19.73-2.5a21.68,21.68,0,0,1-8.29-4,3.12,3.12,0,0,1-1.14-2.44l.1-13.08Z"
          fill="#efc1ab"
        />
        <path
          d="M429.11,216c-6.84,3.77-11.61,5.34-20.75-.52v-3.61h20.78Z"
          fill="#9e6352"
          opacity={0.3}
          style={{
            mixBlendMode: "multiply",
          }}
        />
        <path
          d="M438.54,188l-.4,0,1-7.6c1.28-13.23-9.44-19.87-19.94-19.9h0c-9.57,0-18.56,3.73-19.78,15.68a26.87,26.87,0,0,0,0,5.38l.65,6.33h-.17a4.3,4.3,0,0,0,0,8.59l.3,0c1.08,9.83,6.83,20.65,18.66,20.65h0c12.56,0,18-10.74,19.12-20.58a3.07,3.07,0,0,0,.53.05,4.3,4.3,0,0,0,0-8.59Z"
          fill="#efc1ab"
        />
        <g>
          <path
            d="M440,190.44A3,3,0,0,0,439,191.8a3.75,3.75,0,0,0-.12,1.91c0,.23.4.13.36-.1a3.37,3.37,0,0,1,.11-1.67,2.56,2.56,0,0,1,.91-1.17c.19-.15,0-.47-.19-.33Z"
            fill="#352d2d"
          />
          <path
            d="M439.18,192.22h.41l.14,0h.06l0,0h0l.1.05,0,0h0l0,0a.3.3,0,0,1,.08.08l0,0h0l0,0a.31.31,0,0,1,0,.1l0,0h0l0,.05,0,.1a.13.13,0,0,0,0,.06s0,0,0,0V193s0,.07,0,.1,0,0,0,0v0a.13.13,0,0,0,0,.06.56.56,0,0,1,0,.12l0,.05s0,0,0,0l-.06.11,0,0s0,0,0,0l0,0a.19.19,0,0,0,0,.27.18.18,0,0,0,.26,0,1.33,1.33,0,0,0,.31-1,1.06,1.06,0,0,0-.68-.82,1.75,1.75,0,0,0-.82-.06.2.2,0,0,0-.13.23.19.19,0,0,0,.23.13Z"
            fill="#352d2d"
          />
        </g>
        <g>
          <path
            d="M398.21,190.71a2.59,2.59,0,0,1,.9,1.17,3.27,3.27,0,0,1,.09,1.67c0,.24.33.34.37.1a3.83,3.83,0,0,0-.11-1.9,3.11,3.11,0,0,0-1.06-1.37c-.19-.14-.38.18-.19.33Z"
            fill="#352d2d"
          />
          <path
            d="M399.34,191.81a1.38,1.38,0,0,0-1.25.33,1.17,1.17,0,0,0-.24,1,1.31,1.31,0,0,0,.29.56.18.18,0,0,0,.26,0,.19.19,0,0,0,0-.27s0-.05,0,0l0,0-.06-.09,0-.05v0s0,0,0,0a.72.72,0,0,1-.06-.21s0-.06,0,0v0a.41.41,0,0,1,0-.11v0s0-.07,0,0a1.17,1.17,0,0,1,.05-.2s0,0,0,0a.08.08,0,0,1,0,0l.06-.09s0,0,0,0l0,0,0,0,0,0h0l.09-.06,0,0h0l.14,0,.07,0h.06a1.37,1.37,0,0,1,.35,0,.2.2,0,0,0,.23-.13c0-.09,0-.22-.13-.23Z"
            fill="#352d2d"
          />
        </g>
        <path
          d="M431.92,184.44a44.1,44.1,0,0,0-7.63-.2,1,1,0,1,1-.23-1.93c2.59-.78,6.23,0,7.81.48S433.58,184.72,431.92,184.44Z"
          fill="#512c10"
        />
        <path
          d="M406.27,184.28a42.57,42.57,0,0,1,7.59-.21,1,1,0,1,0,.23-1.92c-2.58-.78-6.2,0-7.77.47S404.63,184.55,406.27,184.28Z"
          fill="#512c10"
        />
        <path
          d="M447.63,170.88c-2.58-3.65-13.3-12.33-21.16-16-1.27-.59-4.94-1.91-7.79.5-2.78-2.36-6.85-1.52-9-.61-2.72,1.13-3.82,2.12-6.2,3.32-2.05,1-7,7.35-9.44,10.9-3.6,5.18,2,23,6,19,.32-.32,0-14,10.36-18.13,5.53-2.2,7-3.1,7.8-5.17a7.74,7.74,0,0,0,3.67,4.61c2.2,1.53,5.46,2.19,6.79,4.13,1.16,1.69,8.78,13.89,10.53,15.57,6.45,6.2,10-1.43,10.58-4C451.06,179,450,174.22,447.63,170.88Z"
          fill="url(#New_Pattern_Swatch_3)"
        />
        <path
          d="M417.35,196a2.14,2.14,0,0,0,.32,2.38,2,2,0,0,0,2.17.24,3.19,3.19,0,0,0,1.25-1.11c.14-.2-.18-.38-.32-.19a2.36,2.36,0,0,1-2,1.14,1.32,1.32,0,0,1-1.26-1,2.23,2.23,0,0,1,.16-1.32c.09-.22-.27-.32-.36-.1Z"
          fill="#352d2d"
        />
        <path
          d="M426.25,311.68c20.82,9.24,46.54,9.8,55.39,12.31,8.29,2.36,10.43,8.76,21.88,13.5,2.3.95,4.93,1.48,7.42.38,2.91-1.29,6.45-4.79,4.91-8.87-1.66-4.41-14.35-8.62-14-10.16.35-1.38,10.54.64,11.08-1.3.72-2.6-6.45-5.14-14.67-6.68a69.17,69.17,0,0,0-12.1-1.4c-14.68-.81-46-14.73-50.61-15.26Z"
          fill="#efc1ab"
        />
        <path
          d="M375.29,344.88h-52a4.2,4.2,0,0,1,4.2-4.2H371.1a4.2,4.2,0,0,1,4.19,4.2Z"
          fill="#ffd04d"
        />
        <path
          d="M525.78,344.88h-52a4.19,4.19,0,0,1,4.19-4.2h43.63a4.2,4.2,0,0,1,4.19,4.2Z"
          fill="#ffd04d"
        />
        <path
          d="M485.12,260.32A146,146,0,0,0,477,275.11c-.2.45.46.85.67.39a146,146,0,0,1,8.08-14.79.39.39,0,0,0-.67-.39Z"
          fill="#c767ce"
        />
        <path
          d="M385.82,293.16a65.17,65.17,0,0,0,15.51,11.2,82.6,82.6,0,0,0,17.13,7.21,28.14,28.14,0,0,0,7.34,1.24.39.39,0,0,0,0-.77c-4.88,0-9.85-1.9-14.31-3.71a89.18,89.18,0,0,1-17.21-9.19,53.85,53.85,0,0,1-7.92-6.52c-.34-.36-.89.19-.54.54Z"
          fill="#c767ce"
        />
        <path
          d="M474.94,267.5l5.23-3.55c.81-.55,1.61-1.12,2.45-1.63A15.79,15.79,0,0,1,485.5,261c.46-.16.26-.91-.21-.74a16.83,16.83,0,0,0-2.73,1.16c-.9.52-1.75,1.12-2.61,1.71l-5.4,3.66c-.41.28,0,.95.39.67Z"
          fill="#c767ce"
        />
        <path
          d="M402.26,272a28.25,28.25,0,0,0,1.11,5c.3.8,1,1.09,1.69,1.45,7,3.48,13.92,7,20.84,10.64,3.13,1.62,6.31,3.19,9.34,5a.39.39,0,0,0,.39-.67c-2.53-1.49-5.18-2.81-7.78-4.17q-5.94-3.09-11.89-6.12c-3.2-1.63-6.4-3.27-9.62-4.88l-1.24-.62a2.22,2.22,0,0,1-1.23-1.71c-.21-.87-.4-1.75-.58-2.62-.69-3.46-1.13-6.95-1.57-10.44-.94-7.49-1.88-15.09-5.08-22-.2-.45-.87-.06-.66.39h0c3,6.47,4,13.6,4.84,20.6"
          fill="#c767ce"
        />
        <path
          d="M397.34,231.39a1.21,1.21,0,0,0,0,.18,7.13,7.13,0,0,0-1.77,6.85c.94,3.73,4.37,6.08,7.67,5.25s5.21-4.52,4.27-8.25a6.92,6.92,0,0,0-5.68-5.37c.14-.24.26-.49.41-.72s.35-.52.54-.78l.18-.24.23-.28a17.41,17.41,0,0,1,1.25-1.33l.64-.58.37-.31.19-.15a16.26,16.26,0,0,1,1.46-1c.32-.19.54-.31.87-.48a3.85,3.85,0,0,0,.44-1.8v-2.17A18.49,18.49,0,0,0,397.34,231.39Z"
          fill="#333"
        />
        <path
          d="M404.06,277.42c-3.74,1.73-7.63,4.09-8.93,8.25-.15.47.59.68.74.2,1.24-3.95,5-6.15,8.58-7.78.45-.21.06-.88-.39-.67Z"
          fill="#c767ce"
        />
        <path
          d="M403.64,276.76A29.85,29.85,0,0,0,391,278c-.47.15-.26.9.21.74a29.35,29.35,0,0,1,12.45-1.25c.49.06.49-.71,0-.77Z"
          fill="#c767ce"
        />
        <rect
          x={279.16}
          y={344.16}
          width={286.78}
          height={59.37}
          rx={6.39}
          fill="#191b30"
        />
        <path
          d="M565.41,354.2h-7.69l-20.73,0-30.87,0-37.4,0-41.24,0-41.34,0-38.82,0-32.58,0-23.59,0c-3.7,0-7.41,0-11.11,0h-.48a.39.39,0,0,0,0,.77H308l30.87,0,37.4,0,41.24,0,41.34,0,38.82,0,32.58,0,23.59,0c3.7,0,7.41,0,11.11,0h.48a.39.39,0,0,0,0-.77Z"
          fill="#ffd04d"
        />
        <path
          d="M419.5,207.52c-2.74.48-4.65-.36-5.38-1.15a.24.24,0,0,1,.13-.4s3-.29,4.89-.63,4.84-1.06,4.84-1.06c.19,0,.28,0,.21.2C423.82,205.46,422.42,207,419.5,207.52Z"
          fill="#fff"
        />
        <path
          d="M541.68,450.36H509.44a12.26,12.26,0,0,0-4.13.54c-1.66.58-2.56,1.54-2.59,2.56-.05,1.35,0,2.7,0,4v82.31c0,.25.77.25.77,0V454a2.56,2.56,0,0,1,1.88-2.62,10.92,10.92,0,0,1,4.27-.61h32c.5,0,.5-.4,0-.4Z"
          fill="#ffd04d"
        />
        <path
          d="M550.07,450.36h32.24a13.8,13.8,0,0,1,4.14.48c1.65.52,2.55,1.37,2.59,2.28,0,1.19,0,2.39,0,3.59v73.12c0,.23-.78.23-.78,0V453.58c0-.87-.26-1.71-1.88-2.33a12.39,12.39,0,0,0-4.27-.54h-32c-.5,0-.5-.35,0-.35Z"
          fill="#ffd04d"
        />
        <path
          d="M440.09,232.07s0-.08,0-.11a18.43,18.43,0,0,0-11-11.17l0,2.16a3.18,3.18,0,0,0,.44,1.8c.34.17.55.3.87.49a15.61,15.61,0,0,1,1.46,1l.19.15.36.3.65.59a15.61,15.61,0,0,1,1.24,1.33l.23.28s.17.22.18.24q.29.38.54.78c.16.23.28.48.42.72A6.94,6.94,0,0,0,430,236c-.94,3.72,1,7.42,4.27,8.25S441,242.71,442,239A7.06,7.06,0,0,0,440.09,232.07Z"
          fill="#333"
        />
        <path
          d="M277.68,448.36H245.44a10,10,0,0,0-4.13.67,3.77,3.77,0,0,0-2.59,3.2c-.05,1.67,0,3.35,0,5v102.5c0,.32.77.32.77,0V452.88a3.27,3.27,0,0,1,1.88-3.27,9,9,0,0,1,4.27-.75h32c.5,0,.5-.5,0-.5Z"
          fill="#ffd04d"
        />
        <path
          d="M284.07,448.36h32.24a13.76,13.76,0,0,1,4.14.48c1.65.52,2.55,1.37,2.59,2.28,0,1.19,0,2.39,0,3.59v73.12c0,.23-.77.23-.77,0V451.58c0-.87-.27-1.71-1.89-2.33a12.39,12.39,0,0,0-4.27-.54h-32c-.5,0-.5-.35,0-.35Z"
          fill="#ffd04d"
        />
        <g>
          <path
            d="M280.87,523.55a29.76,29.76,0,1,1,29.75-29.76A29.79,29.79,0,0,1,280.87,523.55Zm0-58.56a28.81,28.81,0,1,0,28.8,28.8A28.83,28.83,0,0,0,280.87,465Z"
            fill="#ffd04d"
          />
          <path
            d="M280.87,505.12a11.33,11.33,0,1,1,11.33-11.33A11.35,11.35,0,0,1,280.87,505.12Zm0-21.7a10.38,10.38,0,1,0,10.38,10.37A10.39,10.39,0,0,0,280.87,483.42Z"
            fill="#ffd04d"
          />
        </g>
        <g>
          <path
            d="M546.87,526.55a29.76,29.76,0,1,1,29.75-29.76A29.79,29.79,0,0,1,546.87,526.55Zm0-58.56a28.81,28.81,0,1,0,28.8,28.8A28.83,28.83,0,0,0,546.87,468Z"
            fill="#ffd04d"
          />
          <path
            d="M546.87,508.12a11.33,11.33,0,1,1,11.33-11.33A11.35,11.35,0,0,1,546.87,508.12Zm0-21.7a10.38,10.38,0,1,0,10.38,10.37A10.39,10.39,0,0,0,546.87,486.42Z"
            fill="#ffd04d"
          />
        </g>
      </g>
      <g id="Layer_13" data-name="Layer 13">
        <g>
          <path
            d="M256.48,195.6A2.91,2.91,0,1,1,253.1,198,2.92,2.92,0,0,1,256.48,195.6Z"
            fill="url(#New_Pattern_Swatch_3-3)"
          />
          <path
            d="M238.87,178.7a2.91,2.91,0,1,1-3.38,2.35A2.91,2.91,0,0,1,238.87,178.7Z"
            fill="url(#New_Pattern_Swatch_3-3)"
          />
          <path
            d="M268.53,218l-6.77-1.21a.65.65,0,0,1-.53-.75l.62-3.48a.66.66,0,0,1,.76-.53l6.77,1.21a.65.65,0,0,1,.53.75l-.62,3.48A.65.65,0,0,1,268.53,218Z"
            fill="url(#New_Pattern_Swatch_4)"
          />
          <path
            d="M272.32,185.17l5.64-3.93a.63.63,0,0,1,.9.16l2,2.9a.65.65,0,0,1-.17.9l-5.64,3.94a.65.65,0,0,1-.9-.16l-2-2.9A.66.66,0,0,1,272.32,185.17Z"
            fill="url(#New_Pattern_Swatch_4)"
          />
          <path
            d="M227.66,239a2.91,2.91,0,1,1-3,2.82A2.91,2.91,0,0,1,227.66,239Z"
            fill="url(#New_Pattern_Swatch_3-3)"
          />
          <path
            d="M202.78,215.13a2.91,2.91,0,1,1-3,2.83A2.91,2.91,0,0,1,202.78,215.13Z"
            fill="url(#New_Pattern_Swatch_3-3)"
          />
          <path
            d="M202.5,249.37l.2-6.88a.65.65,0,0,0-.63-.67l-3.54-.1a.65.65,0,0,0-.67.63l-.2,6.88a.65.65,0,0,0,.63.67l3.54.1A.65.65,0,0,0,202.5,249.37Z"
            fill="url(#New_Pattern_Swatch_4)"
          />
          <path
            d="M178.14,226.45l-4.72-5a.65.65,0,0,0-.92,0l-2.57,2.42a.65.65,0,0,0,0,.92l4.71,5a.66.66,0,0,0,.93,0l2.57-2.42A.65.65,0,0,0,178.14,226.45Z"
            fill="url(#New_Pattern_Swatch_4)"
          />
          <g>
            <path
              d="M237.56,201.1l-5.76-3.59a3,3,0,0,1,1.42,2.69l-.36,9.1a3,3,0,0,0,1.43,2.69l3,1.87a.89.89,0,0,0,1.36-.72l.34-9.35A3,3,0,0,0,237.56,201.1Z"
              fill="#f15931"
            />
            <path
              d="M231.8,197.51l-.43-.26a3,3,0,0,0-3-.09L221.24,201l.32-8.06a3,3,0,0,0-1.43-2.69l-5.76-3.59-.42-.26a3,3,0,0,0-3-.1l-7.09,3.84.32-8.06a3,3,0,0,0-1.43-2.69l-3-1.86a.89.89,0,0,0-1.36.72L198,187.6a3,3,0,0,0,1.43,2.68l5.76,3.59.43.27a3,3,0,0,0,3,.09l7.09-3.84-.32,8.06a3,3,0,0,0,1.43,2.69l5.76,3.59a3,3,0,0,1-1.35-1.89,3,3,0,0,0,1.35,1.89l.43.26a3,3,0,0,0,3,.09l7.09-3.84,0-1A3,3,0,0,0,231.8,197.51Z"
              fill="#f15931"
            />
          </g>
          <g>
            <path
              d="M255.59,163.92l-1.45,3.48a1,1,0,0,0,1,1.3l9.89-1.26a3.22,3.22,0,0,0,2.58-2l2.77-6.68a3.21,3.21,0,0,1-2.58,2l-9.62,1.2A3.21,3.21,0,0,0,255.59,163.92Z"
              fill="#f15931"
            />
            <path
              d="M284.83,120.34,275,121.59a3.21,3.21,0,0,0-2.58,2l-2.77,6.67-.21.49a3.23,3.23,0,0,0,.43,3.21l5.26,6.79-8.52,1.06a3.24,3.24,0,0,0-2.58,2l-2.77,6.67a3.21,3.21,0,0,1,1.75-1.74,3.21,3.21,0,0,0-1.75,1.74l-.21.49a3.23,3.23,0,0,0,.43,3.21l5.26,6.79,1.1-.14a3.21,3.21,0,0,0,2.58-2l.21-.49a3.23,3.23,0,0,0-.43-3.21l-5.26-6.79,8.52-1.06a3.22,3.22,0,0,0,2.58-2l2.77-6.67.21-.49a3.25,3.25,0,0,0-.43-3.22l-5.27-6.78,8.53-1.06a3.26,3.26,0,0,0,2.58-2l1.44-3.47A.94.94,0,0,0,284.83,120.34Z"
              fill="#f15931"
            />
          </g>
          <g>
            <path
              d="M240.14,148.51l-1.63-3.82a1.87,1.87,0,0,1-.23,1.85L234.9,151a1.82,1.82,0,0,0-.22,1.84l.85,2a.54.54,0,0,0,.93.11l3.45-4.57A1.87,1.87,0,0,0,240.14,148.51Z"
              fill="url(#New_Pattern_Swatch_2)"
            />
            <path
              d="M238.5,144.69l-.11-.28a1.88,1.88,0,0,0-1.5-1.12l-4.9-.56,3-3.93a1.84,1.84,0,0,0,.23-1.85l-1.63-3.82-.12-.28a1.87,1.87,0,0,0-1.49-1.12l-4.91-.56,3-3.93a1.87,1.87,0,0,0,.23-1.85l-.85-2a.54.54,0,0,0-.93-.11L225,127.86a1.86,1.86,0,0,0-.23,1.85l1.64,3.82.12.28a1.84,1.84,0,0,0,1.49,1.11l4.9.56-3,3.94a1.84,1.84,0,0,0-.23,1.85l1.63,3.82a1.89,1.89,0,0,1,0-1.42,1.89,1.89,0,0,0,0,1.42l.12.28a1.84,1.84,0,0,0,1.49,1.11l4.91.56.39-.5A1.84,1.84,0,0,0,238.5,144.69Z"
              fill="url(#New_Pattern_Swatch_2)"
            />
          </g>
          <path
            d="M162.22,188.6l2.74-6.31a.66.66,0,0,0-.34-.86L161.38,180a.66.66,0,0,0-.86.34l-2.74,6.31a.66.66,0,0,0,.34.86l3.24,1.41A.66.66,0,0,0,162.22,188.6Z"
            fill="url(#New_Pattern_Swatch_4)"
          />
        </g>
      </g>
      <g id="People">
        <g>
          <g>
            <g>
              <path
                d="M198.88,382s-10.25-1-12.77-8.51-4.82-34.34-3-36.24,3.43,10.86,5.33,18.94c0,.37-1.66-18.18.07-20s4.45,14.23,4.62,19.41,4.65-2.28,9.56,14.3S198.88,382,198.88,382Z"
                fill="#ad6b55"
              />
              <path
                d="M193.36,358.62s-.36-4.33.42-4.26,3.4.13,3.84,1.67a5.35,5.35,0,0,1,.33,2s.46-1.13,1.34-.73,3.42.87,2.85,3.07,1.05,7.77.11,9.91S193.36,358.62,193.36,358.62Z"
                fill="#ad6b55"
              />
            </g>
            <path
              d="M193,375.66a.21.21,0,0,0,.19-.11,7.32,7.32,0,0,0-1.72-9.41,15.93,15.93,0,0,0,3.49-1.19c1.33-.57,2.09-1.23,2.24-1.94a1.17,1.17,0,0,0-.23-1l-.07-.08h-.11l-8.4.55-3.65,5.92a.22.22,0,0,0,.07.3.22.22,0,0,0,.31-.07l3.53-5.72,8-.52a.76.76,0,0,1,.08.56c-.09.39-.51,1-2,1.63-2.92,1.27-3.85,1.2-3.85,1.2l-.85-.08.7.48a6.92,6.92,0,0,1,2,9.18.23.23,0,0,0,.09.31Z"
              fill="#9c5844"
            />
          </g>
          <path
            d="M141.92,387.3s-1.92,20.4-13.78,24.88-12.21,27.9,3.92,34.49,37.22,2.64,43.29-7.64-17.76-16.18-16.69-36.23C156,394.35,141.92,387.3,141.92,387.3Z"
            fill="#ad6b55"
          />
          <path
            d="M139.7,397.46s6.05,19.44,17.89,13C166.09,406.74,139.7,397.46,139.7,397.46Z"
            fill="#9c5844"
          />
          <path
            d="M161.57,415.29a61.15,61.15,0,0,1,18.87,9.84c10.65,6.35,29,16.29,29,16.29s-7.69-25.75-10.93-35.32c-8-23.61-6.46-34.41-6.46-34.41s.35-9.79,5.88-5.06,15.32,34.19,19.74,43.76,20.84,47.53,9.18,55.52-60.51-27.47-74.54-25.11C142.41,441.41,161.57,415.29,161.57,415.29Z"
            fill="#ad6b55"
          />
          <path
            d="M98.15,579.85s-6,43.24,4,191.38c2,11.73,15.08,14.07,19.1,0s10.5-184.07,10.5-184.07Z"
            fill="#ad6b55"
          />
          <path
            d="M175.44,357.15s5.43,50.9-13.34,51.19-27-15.23-28.88-26.14,0-32.4,19.64-32.57S175.44,357.15,175.44,357.15Z"
            fill="#ad6b55"
          />
          <path
            d="M180.69,582.92s38.68,139.76,41.23,172.5c1.35,17.45-15.3,6.63-19.89-5.06-10.18-25.94-54.83-155.51-54.83-155.51Z"
            fill="#ad6b55"
          />
          <path
            d="M176.53,432.65s7.92,16,2.77,34.2-2.77,56.55-2.77,56.55-31.13,10.67-62.77-7.52c-1.19-1.19-1.76-16.16,4.9-23.33,9.4-10.1-5.26-48,.2-68.87C129.87,422.55,176.53,432.65,176.53,432.65Z"
            fill="#ad6b55"
          />
          <path
            d="M176.53,432.65s-6.42,13.65-57.87-2.65c-1.41-.78-3.17,15.52,3,41.36,0,0,38.46-2.83,56.27,2.11,0-.12,3.77-10.9,4.71-16.82S186.35,444.23,176.53,432.65Z"
            fill="#26211d"
          />
          <path
            d="M176,499.64s-26.3,9.37-59-4.87c-.43.71-21.84,27.14-32.37,107.26-.76-1.13,44.38,26.33,112.09,3C196.69,605,176.44,511.13,176,499.64Z"
            fill="#26211d"
          />
          <path
            d="M124.06,436.84s-5,18.87-9.37,30.9c-6.4,17.68-40,82.49-40,82.49s-2.1,17.1-13.68,23.66c-3.46,2.26,7.23-10,4.88-17-2-3.87-19.82,12.35-19.82,12.35a21.61,21.61,0,0,0-2.63,5.51,1.39,1.39,0,0,1-2.57.22c-1.27-2.51-2.77-5.89-2.7-7.76.13-3.28,2-12.32,8.14-15.47s16.3-10.23,16.3-10.23S98,467.12,98.78,455.83c.57-8.55,5-25.57,7.2-31.28,0,0,3.35-15.19,19.86-12.89S124.06,436.84,124.06,436.84Z"
            fill="#ad6b55"
          />
          <path
            d="M176.53,432.65l-10.07-16-1.6-.34s10.31,20.58-4.66,20.48-23.44-3.63-26.7-9.28-5.36-15.31-5.36-15.31l-2.3-.52s4.16,16.14.39,22.19C125.6,439.41,175.93,451.6,176.53,432.65Z"
            fill="#26211d"
          />
          <g>
            <path
              d="M138.63,387s1.4,8-2.24,10.94c0-.1-1.89-4.29-4.52-10.94S138.63,387,138.63,387Z"
              fill="#a32b28"
            />
            <path
              d="M137.13,356.9s-.25-9.66-8.65-7.27-10.28,8.78-7.27,12.91,13.79,4.64,15,.63A15,15,0,0,0,137.13,356.9Z"
              fill="#a32b28"
            />
            <g>
              <path
                d="M169,357.59s1.51,9.69-2.91,14.3-5.89,11.66-5.89,11.66,1.94-6.4,6-9.88,6.84-14.86,4.6-17.3S169,357.59,169,357.59Z"
                fill="#a32b28"
              />
              <g>
                <path
                  d="M143.28,373s-.85,31.14,1.6,41.66c-.2-.39-2.83,0-2.83,0s-5.35-22-4.89-28.4c-.87.83-1.45,5.55-2.28,7.81s-7.12-1.89-7.12-1.89-5.68-35.81,12.88-42.77,26,3.09,26,3.09Z"
                  fill="#a02410"
                />
                <path
                  d="M170.43,359.35c-.22.38-4.52,11.72-14.17,11.72s-10.66,8.07-15.55,6.23-2-10.61,3-17,6.63-13.89,15.6-12.42S173.44,353.94,170.43,359.35Z"
                  fill="#a02410"
                />
                <path
                  d="M176.15,370.19s-1.08-9.93-7.06-11.38c-7.51-1.82-7.35-7.69-1.75-8.25S182,358.26,176.15,370.19Z"
                  fill="#a32b28"
                />
              </g>
            </g>
          </g>
          <g>
            <path
              d="M261.34,779s2.54,7.9-2.07,10.57c-7,4-24.33,2.69-30.67-2S215.69,781,208.24,782s-15.51-2.6-11.46-12.8C199.48,762.36,261.34,779,261.34,779Z"
              fill="#677693"
            />
            <path
              d="M218.93,736.05s-12.75,6.18-21.17,2.94c0,0,6,15.79,1.22,24.4-4.4,7.85-3.14,14.29,5.05,14.57s17.66.52,24.43,4.55c4.92,2.29,22.09,7.94,29.34,1.72,9.57-5-1.37-12-12.24-12.18a8.57,8.57,0,0,1-7-2.23c-3.29-3-4.88-5.11-8.92-7.68S221.84,737.07,218.93,736.05Z"
              fill="#26211d"
            />
          </g>
          <g>
            <path
              d="M125.25,801.9s.06,6.76-3.54,8.28-27.52-.85-29.23-5.53a7.64,7.64,0,0,1,0-7Z"
              fill="#677693"
            />
            <path
              d="M101.32,773.14s-11,22.62-8.44,26.55c5.09,6,30.51,6.34,32.37,2.21s-5.17-26.36-5.17-26.36S110,770.88,101.32,773.14Z"
              fill="#26211d"
            />
          </g>
          <g opacity={0.54}>
            <path
              d="M91.86,605c5.87-60.46,30.73-107.4,31-107.87l-.65-.35c-.25.47-25.18,47.54-31.07,108.15Z"
              fill="#e49e38"
            />
            <path
              d="M101,608.3c8.57-63.1,26.93-109,27.12-109.43l-.69-.28c-.18.46-18.58,46.42-27.16,109.61Z"
              fill="#e49e38"
            />
            <path
              d="M111.23,611c2.35-49.46,22.17-110.08,22.37-110.69l-.7-.23c-.2.61-20.05,61.32-22.4,110.89Z"
              fill="#e49e38"
            />
            <path
              d="M122.15,611h.73c-.26-37.32,17-108.7,17.16-109.41l-.71-.18C139.15,502.12,121.88,573.58,122.15,611Z"
              fill="#e49e38"
            />
            <path
              d="M134.2,614.26l.73,0c-.74-34.87,12.33-111,12.46-111.8l-.72-.12C146.54,503.08,133.45,579.32,134.2,614.26Z"
              fill="#e49e38"
            />
            <path
              d="M147.75,614.31l.72-.12c-5.2-33.36,3.93-110.73,4-111.5l-.73-.09C151.67,503.38,142.53,580.84,147.75,614.31Z"
              fill="#e49e38"
            />
            <path
              d="M189.07,607.48l.71-.2c-10.16-35.47-17.5-105.83-17.57-106.54l-.74.08C171.55,501.53,178.89,572,189.07,607.48Z"
              fill="#e69f39"
            />
            <path
              d="M178.12,610.38l.71-.21c-8.15-27.38-13.68-107-13.74-107.82l-.73,0C164.41,503.21,170,582.92,178.12,610.38Z"
              fill="#e49e38"
            />
            <path
              d="M163.05,613.11l.72-.15c-6.49-30.61-4.72-109.51-4.7-110.31l-.73,0C158.32,503.43,156.54,582.42,163.05,613.11Z"
              fill="#e49e38"
            />
          </g>
          <path
            d="M120.91,778.27l3.42-37.48s-12.11,2.58-24.09,0c0,.23,1.43,36.15,1.43,36.15Z"
            fill="#26211d"
          />
        </g>
      </g>
      <g id="eyes">
        <g>
          <g>
            <polygon
              points="396.43 986.16 385.25 998.05 374.9 990.58 385.09 977.48 396.43 986.16"
              fill="#ffa18a"
            />
            <path
              d="M376.82,988.13c-2.52-2-17.54,10.84-17.1,14.34s4.63,8.48,7.41,13.71a56.41,56.41,0,0,0,9.74,13.26c4.64,4.53,9.89,7.82,13.51,4.56,9-8.14-5.11-23.8-2.05-33.7.56-1.83,2.28-5-.19-6.26-4.06-2-6.83,1.19-8.6-.18C376.11,991.24,376.82,988.13,376.82,988.13Z"
              fill="#f15931"
            />
          </g>
          <path
            d="M447,541.55c-.53-5.18-3.41-8.22-2.32-16.48,1-7.85,7.17-9.78,9.22-21,.4-2.21.61-4.62-.74-6.68-1.57-2.41-5.22-5.06-8.63-3.1-3.7,2.13-5.61,14.07-7.05,13.94-1.27-.11-1-9.51-2.77-9.7-2.42-.27-3.84,6.56-4,14.12a48.45,48.45,0,0,0,.7,11c1.88,13.16.87,16.95,1.35,22.07Z"
            fill="#ffa18a"
          />
          <path
            d="M292.94,535c.38-5.19,3.17-8.32,1.84-16.54-1.27-7.82-7.46-9.56-9.84-20.75-.46-2.2-.74-4.6.54-6.7,1.51-2.46,5.07-5.21,8.54-3.35,3.76,2,6,13.9,7.46,13.73,1.27-.15.68-9.53,2.48-9.79,2.42-.33,4,6.45,4.43,14a48.54,48.54,0,0,1-.37,11c-1.5,13.21-.37,17-.71,22.1Z"
            fill="#ffa18a"
          />
          <g>
            <polygon
              points="287.08 996.83 278.4 1010.65 266.8 1005.3 274.29 990.49 287.08 996.83"
              fill="#ffa18a"
            />
            <path
              d="M268.22,1002.53c-2.86-1.45-15.13,14-14,17.36s6.18,7.43,9.9,12a56.84,56.84,0,0,0,12.11,11.15c5.42,3.55,11.2,5.77,14.14,1.87,7.3-9.72-9.59-22.37-8.49-32.68.2-1.89,1.27-5.39-1.39-6.1-4.36-1.16-6.47,2.47-8.47,1.48C268.12,1005.72,268.22,1002.53,268.22,1002.53Z"
              fill="#f15931"
            />
          </g>
          <path
            d="M323.05,783.78c-6.48,11.9-20.42,127.32-62.13,207.24,0,0,28.85,17.34,33.44,11.63,29.44-36.6,65.27-193.32,81-193.89,7-.25,41.71,72.45,39.93,88.07-4.43,38.84-34.9,64.3-42.15,77.49,0,0,24,25,27.51,21.61,22.2-21.47,51.56-71.66,53.22-88.72C457.48,870,437.5,818.7,425.18,778.5Z"
            fill="#576949"
          />
          <path
            d="M291.55,522.82c.92-2.63,19.1-.11,18.94,3.78-.45,10.9-3.93,24.66-1.32,47.49s18.61,48.1,45.48,63.67l32.94,0c18.21-5.46,37.26-32.7,42.34-60.31,4.33-23.53-.42-36-.81-47.34-.06-1.74,16.12-4.4,17.66-.64,6.19,15.1,7.24,37.58,6.82,50.25-1.57,46.72-32.87,76.56-33,87.28-.33,36.56,20.85,115.23,22.91,146.14a19.85,19.85,0,0,1-12.65,5.51s-13-21.29-15.88-37.93L339.48,786c-5.63,18.08-13.62,29.42-13.62,29.42l-20.56-4.51c-5.51-40.52,23.91-115,18.08-149.08-2.08-12.14-31.88-29.67-38.69-82C284,574.56,285.74,539.46,291.55,522.82Z"
            fill="url(#New_Pattern_Swatch_3-11)"
          />
          <path
            d="M290.16,530.32c5,.28,10.2.77,14.57,3.45.4.24.76-.38.36-.63-4.47-2.74-9.8-3.26-14.93-3.54-.47,0-.47.7,0,.72Z"
            fill="#fffaf8"
          />
          <path
            d="M431,540.21a38.33,38.33,0,0,1,15-1.66c.46.05.46-.68,0-.72a38.92,38.92,0,0,0-15.16,1.68c-.44.14-.25.84.19.7Z"
            fill="#fffaf8"
          />
          <path
            d="M323.33,659.25a23.61,23.61,0,0,1,1.35-9.47,33.94,33.94,0,0,1,5.37-8.75c.29-.36-.22-.87-.51-.51a36,36,0,0,0-5.45,8.8,24,24,0,0,0-1.48,9.93c0,.46.74.46.72,0Z"
            fill="#fffaf8"
          />
          <path
            d="M323.28,659.43a22.73,22.73,0,0,1,2.81-4.43,12.26,12.26,0,0,1,4.19-3c.42-.2.05-.82-.37-.63a12.76,12.76,0,0,0-4.33,3.07,23.07,23.07,0,0,0-2.93,4.57c-.21.42.41.78.63.37Z"
            fill="#fffaf8"
          />
          <path
            d="M420.73,664.91c-.58-3-1.07-6.11-1.8-9.12a42.5,42.5,0,0,0-3.18-8.12c-.2-.42-.83,0-.63.37a41,41,0,0,1,3.18,8.26c.69,2.91,1.17,5.87,1.73,8.8.09.45.79.26.7-.19Z"
            fill="#fffaf8"
          />
          <g>
            <path
              d="M339.48,786a108.38,108.38,0,0,1,33.74,3c17,4.35,41.8-8.21,41.8-8.21-6.38-17.72-8.16-114.77-27.43-143l-16.47,2.29-16.47-2.34c-4.84,11.17-10.79,35.82-7.21,62.64C354.65,754.36,339.48,786,339.48,786Z"
              fill="#fff"
            />
            <g clipPath="url(#clip-path)">
              <path
                d="M339.48,786a108.38,108.38,0,0,1,33.74,3c17,4.35,41.8-8.21,41.8-8.21-6.38-17.72-8.16-114.77-27.43-143l-32.94,0c-4.84,11.17-10.79,35.82-7.21,62.64C354.65,754.36,339.48,786,339.48,786Z"
                fill="#fff"
              />
              <rect
                x={344.61}
                y={673.5}
                width={56.78}
                height={3.98}
                fill="#f15931"
              />
              <rect
                x={345.84}
                y={684.88}
                width={56.92}
                height={3.98}
                fill="#f15931"
              />
            </g>
          </g>
          <path
            d="M359.77,619.76V633a3.81,3.81,0,0,1-1.6,3.09c-2.48,1.77-3.52,1.66-3.52,1.66s4.26,8,16.47,8c14.05,0,16.47-8,16.47-8a7.53,7.53,0,0,1-4.6-1.53,3.21,3.21,0,0,1-1.2-2.6l.1-13.92Z"
            fill="#ffa18a"
          />
          <path
            d="M381.85,625.82c-3.4,3.85-15,4.79-22.08,0v-4.1h22.11Z"
            fill="#ff7a5a"
            opacity={0.4}
          />
          <path
            d="M391.49,596.27l-.42,0,1-7.78c1.34-13.53-9.94-20.34-21-20.36h0c-10.07,0-19.53,3.81-20.82,16.05a26.61,26.61,0,0,0,0,5.5l.68,6.48h-.18a4.4,4.4,0,0,0,0,8.79,1.71,1.71,0,0,0,.32,0c.18,11.6,4.44,21.28,19.61,21.91h0c13.49,0,19.9-9.15,20.16-21.84a3.64,3.64,0,0,0,.57,0,4.4,4.4,0,0,0,0-8.79Z"
            fill="#ffa18a"
          />
          <g>
            <path
              d="M393.05,598.79a3.1,3.1,0,0,0-1.12,1.39,3.69,3.69,0,0,0-.12,2c0,.24.41.14.38-.1a3.31,3.31,0,0,1,.1-1.71,2.68,2.68,0,0,1,1-1.2c.2-.15,0-.48-.2-.33Z"
              fill="#ff7a5a"
            />
            <path
              d="M392.16,600.61a1.66,1.66,0,0,1,.32,0h.12l.14,0,.06,0h0l.11.06,0,0s0,0,0,0l0,0,.09.08v0s0,0,0,0l0,0,.06.1v0h0l0,0,0,.11s0,0,0,.06,0,0,0,0v.22s0,0,0,0v0s0,0,0,.07a.56.56,0,0,1,0,.12s0,0,0,.05,0,0,0,0a.41.41,0,0,1-.07.11l0,0h0l0,0a.19.19,0,0,0,0,.27.2.2,0,0,0,.28,0,1.31,1.31,0,0,0,.32-1.07,1.09,1.09,0,0,0-.71-.84,1.8,1.8,0,0,0-.86-.06.19.19,0,0,0-.14.24c0,.11.13.14.24.13Z"
              fill="#ff7a5a"
            />
          </g>
          <g>
            <path
              d="M349,599.05a2.74,2.74,0,0,1,1,1.21,3.31,3.31,0,0,1,.1,1.71c0,.24.34.35.38.1a3.7,3.7,0,0,0-.11-2,3.18,3.18,0,0,0-1.12-1.4c-.2-.14-.4.19-.2.33Z"
              fill="#ff7a5a"
            />
            <path
              d="M350.21,600.18a1.47,1.47,0,0,0-1.31.35,1.15,1.15,0,0,0-.25,1.05,1.31,1.31,0,0,0,.3.57.19.19,0,0,0,.27,0,.18.18,0,0,0,0-.27s0-.06,0,0l0,0-.06-.1,0-.05v0s0,0,0,0,0-.07,0-.11a.36.36,0,0,1,0-.11s0-.06,0,0v0a.4.4,0,0,1,0-.11v0s0-.08,0,0a.73.73,0,0,1,.06-.21s0,0,0,0l0-.05a.47.47,0,0,1,.06-.09s0,0,0,0l0,0,0,0,0,0s0,0,0,0l.1-.05.05,0h0s0,0,0,0l.14,0h.14a2.14,2.14,0,0,1,.36,0,.21.21,0,0,0,.25-.13.21.21,0,0,0-.14-.24Z"
              fill="#ff7a5a"
            />
          </g>
          <path
            d="M382,558.15c1.84-2.36,5.51-2.23,8.05-1.13,3,1.32,2.41,5.22,1.91,7.86-.24,1.34.91,3.06,2.47,2.46a5.32,5.32,0,0,1,6.73,2.45,5.41,5.41,0,0,1-2.22,6.73,2,2,0,0,0,0,3.45c2.49,1.27,5.82,2.88,6.81,5.73,1.17,3.37-2.08,6.35-4.27,8.41a2,2,0,0,0,0,2.83,8.4,8.4,0,0,1,1.59,10.33,10.36,10.36,0,0,1-10.3,4.64l1.39,2.46a17.6,17.6,0,0,0-.33-7.74l-.92,2.26c4-1.78,7.35-5.62,6.44-10.27a6.56,6.56,0,0,0-3.57-4.72,18,18,0,0,0-2.57-.85c-.29-.09-1.16-.22-1.24-.59s.43-1,.58-1.34a13.14,13.14,0,0,0,.67-1.48,9,9,0,0,0,.6-3.33,7.07,7.07,0,0,0-3.1-5.79c-1.83-1.36-2.23-3.67-3.51-5.47a12.92,12.92,0,0,0-19.38-2.13h2.83c-2.47-2.55-6.29-3.74-9.57-2a6.57,6.57,0,0,0-3.17,3.86c-.47,1.59-.06,3.17-.22,4.77-.13,1.33-1.67,1.48-2.69,2a4.93,4.93,0,0,0-2.87,3.78c-.25,1.62.31,3.31-.18,4.89a4.69,4.69,0,0,1-2.49,2.85c-1.74.77-3.51.87-5,2.25a7,7,0,0,0-2.1,4.46,6.88,6.88,0,0,0,1.65,4.87,6.46,6.46,0,0,0,2,1.58,7.56,7.56,0,0,1,2.05,1,1.71,1.71,0,0,1-.24,2.56,4.31,4.31,0,0,1-3.38.1,13.7,13.7,0,0,1-7.18-5.48,10.65,10.65,0,0,1-1.62-9.4c1-2.86,3.45-5.62,6.58-6,1.31-.16,2.74-1.65,1.72-3-1.86-2.51-3.55-6.44-1.3-9.26a4.22,4.22,0,0,1,3.19-1.71,13.79,13.79,0,0,1,2,.46,3.14,3.14,0,0,0,2.76-.8c1.24-1.19,1-3,.8-4.48a5.94,5.94,0,0,1,.92-4.24c1.86-2.72,5.46-2.8,7.93-.91,1.31,1,2.9-.4,3-1.72.06-.87.05-2.21.76-2.83.49-.42.51-.29.88.2a14.39,14.39,0,0,0,1.76,2.33,5.4,5.4,0,0,0,3.2,1.29c2.25.18,4.48-.83,6.45-1.78a30.89,30.89,0,0,0,6.24-4.11c2-1.65-.86-4.47-2.83-2.83a26.24,26.24,0,0,1-6.54,4,6.55,6.55,0,0,1-3.14.75c-.9-.12-1.23-1-1.69-1.66-1.38-2-3.58-3.13-5.93-1.91s-3,4-3.16,6.56l3-1.73a9.41,9.41,0,0,0-11.66.34,9.6,9.6,0,0,0-3.05,5.11,9.37,9.37,0,0,0-.19,3c.05.43.15.86.2,1.28q0,.32,0,.63c.06.39.38.25,1-.42-.07-.17-1.16-.36-1.36-.41a6.91,6.91,0,0,0-4.4.55,8.77,8.77,0,0,0-4.12,3.86c-2.13,4.06-.75,8.95,1.84,12.44l1.73-3c-7,.83-11.85,7.76-11,14.67s6.88,13.51,13.82,14.38c3.43.43,7.05-1.3,7.42-5.06a5.85,5.85,0,0,0-1.65-4.65c-1.2-1.17-3.23-1.27-4.09-2.77a2.78,2.78,0,0,1,.69-3.58,7.25,7.25,0,0,1,2.44-.9,8.3,8.3,0,0,0,2.63-1.26,8.94,8.94,0,0,0,3.18-4.26c.63-1.8.23-3.45.33-5.28.09-1.59,2.21-1.65,3.32-2.38a5.68,5.68,0,0,0,2.35-5.17c0-1.66-.39-3.51,1.4-4.38s3.51.11,4.72,1.36a2,2,0,0,0,2.83,0,8.93,8.93,0,0,1,9.77-1.4,9.21,9.21,0,0,1,3.74,3.34c1,1.69,1.54,3.69,3,5.11,1.28,1.23,2.65,1.69,2.63,3.69s-1.3,3.18-1.71,4.91a4.24,4.24,0,0,0,2.15,4.78c1.27.68,2.94.67,4.11,1.48s1.4,2.74.88,4c-.76,1.86-2.61,3-4.36,3.75a2,2,0,0,0-.92,2.26,12.83,12.83,0,0,1,.34,5.61,2,2,0,0,0,1.39,2.46c5.68.86,11.84-1.33,14.82-6.47,2.77-4.78,2-11.48-2.21-15.18v2.83c3.27-3.09,6.71-7.14,5.39-12-1.12-4.14-5.15-6.61-8.74-8.43V580a9.44,9.44,0,0,0,3.79-11.9,9.28,9.28,0,0,0-11.39-4.59l2.46,2.46c.84-4.52,1.06-10.18-3.87-12.43-4-1.8-9.86-1.93-12.78,1.81a2.07,2.07,0,0,0,0,2.83,2,2,0,0,0,2.83,0Z"
            fill="#8f493b"
          />
          <path
            d="M349.13,556.23a1,1,0,0,1-.14.43c.11-.19.1-.18-.05,0s-.22.15,0,0c-.2.07-.18.06,0,0l.37-.08c-.21,0-.2,0,0,0l.72,0c.41,0,.83,0,1.24.07.24,0,.24,0,0,0l.35.06c.24,0,.47.09.7.15a13.44,13.44,0,0,1,1.37.41s.58.23.18.06c.22.09.44.2.65.3a11.62,11.62,0,0,1,1.23.72c.2.13.4.26.59.41-.34-.26.23.2.29.24a2,2,0,1,0,2.82-2.82,14.33,14.33,0,0,0-6.94-3.36,13.21,13.21,0,0,0-4.21-.09,3.66,3.66,0,0,0-3.23,3.47,2,2,0,0,0,4,0Z"
            fill="#8f493b"
          />
          <g>
            <path
              d="M391.49,596.27l-.42,0,0-.29H351v.18h-.18a4.4,4.4,0,0,0,0,8.79,1.71,1.71,0,0,0,.32,0c.18,11.6,4.44,21.28,19.61,21.91,13.49,0,19.9-9.15,20.16-21.84a3.64,3.64,0,0,0,.57,0,4.4,4.4,0,0,0,0-8.79Z"
              fill="#ffa18a"
            />
            <g>
              <path
                d="M392.79,598.38a3.07,3.07,0,0,0-1.13,1.39,3.69,3.69,0,0,0-.12,2c0,.24.42.14.38-.1a3.3,3.3,0,0,1,.11-1.71,2.61,2.61,0,0,1,1-1.2c.2-.15,0-.48-.19-.33Z"
                fill="#ff7a5a"
              />
              <path
                d="M391.89,600.2a1.71,1.71,0,0,1,.32,0h.12l.14,0,.06,0h0l.11.06.05,0s0,0,0,0l0,0a.3.3,0,0,1,.08.08l0,0h0l0,0,.06.1v0s0,0,0,0a.43.43,0,0,0,0,0,.23.23,0,0,1,0,.11.13.13,0,0,1,0,.06h0a.49.49,0,0,1,0,.12s0,.06,0,.1,0,0,0,0v0a.64.64,0,0,0,0,.07l0,.12,0,0s0,0,0,0l-.06.11,0,0h0l0,0a.19.19,0,0,0,0,.27.2.2,0,0,0,.28,0,1.32,1.32,0,0,0,.32-1.07,1.07,1.07,0,0,0-.71-.84,1.67,1.67,0,0,0-.86-.06c-.11,0-.16.15-.14.24a.2.2,0,0,0,.24.13Z"
                fill="#ff7a5a"
              />
            </g>
            <g>
              <path
                d="M348.75,598.64a2.62,2.62,0,0,1,.95,1.21,3.31,3.31,0,0,1,.1,1.71c0,.24.34.34.38.1a3.69,3.69,0,0,0-.11-1.95,3.18,3.18,0,0,0-1.12-1.4c-.2-.15-.39.19-.2.33Z"
                fill="#ff7a5a"
              />
              <path
                d="M349.94,599.77a1.45,1.45,0,0,0-1.31.35,1.18,1.18,0,0,0-.25,1,1.43,1.43,0,0,0,.3.57.2.2,0,0,0,.28,0,.19.19,0,0,0,0-.27s0-.06,0,0l0,0-.06-.1,0,0v0s0,0,0,0a.49.49,0,0,1,0-.11l0-.11s0-.06,0,0,0,0,0,0v-.16s0-.08,0,0l.06-.2s0,0,0,0,0,0,0,0l.06-.09,0,0,0,0,0,0,0,0h0l.09,0,0,0h0l.15,0h.13a2.26,2.26,0,0,1,.37,0,.2.2,0,0,0,.24-.13.2.2,0,0,0-.14-.24Z"
                fill="#ff7a5a"
              />
            </g>
          </g>
          <path
            d="M370.6,603.3c-.2.82-.45,1.63-.7,2.44a10.12,10.12,0,0,0-.45,1.72,1.21,1.21,0,0,0,.25,1.07,1.86,1.86,0,0,0,1.38.41,2.36,2.36,0,0,0,1.75-1.15c.15-.23-.22-.44-.36-.21a1.85,1.85,0,0,1-1.78.94c-.44-.06-.83-.25-.84-.72a5.79,5.79,0,0,1,.39-1.73c.27-.88.55-1.76.77-2.65.06-.26-.35-.38-.41-.12Z"
            fill="#ff7a5a"
          />
          <path
            d="M370.93,615.56c2.69.16,4.44-.82,5.07-1.63a.23.23,0,0,0-.17-.36s-2.92,0-4.79-.1-4.78-.5-4.78-.5c-.18,0-.27.06-.18.21C366.54,614.06,368.05,615.38,370.93,615.56Z"
            fill="#fff"
          />
          <path
            d="M366,590.88c.43-.69.13-1.11-1-1.53a8.68,8.68,0,0,0-3.57-.35c-2.44.31-3.85,2.19-3.14,1.93a9.79,9.79,0,0,1,4.62-.49C364.2,590.52,365.68,591.34,366,590.88Z"
            fill="#824237"
          />
          <path
            d="M375.25,590.88c-.42-.69-.13-1.11,1-1.53a8.75,8.75,0,0,1,3.58-.35c2.43.31,3.85,2.19,3.13,1.93a9.75,9.75,0,0,0-4.61-.49C377,590.52,375.54,591.34,375.25,590.88Z"
            fill="#824237"
          />
          <g>
            <g>
              <path
                d="M402.88,594.54c2.57-2.41,5.35-5.34,5.09-8.87-.3-4.07-4.41-6.58-8-8.41a7.4,7.4,0,0,0,3-9.31,7.31,7.31,0,0,0-9.07-3.52c.61-3.18,1-7-1.36-9.16a7.47,7.47,0,0,0-3.4-1.59c-3-.72-6.71-.44-8.54,2.08l.56.31c-.54.45-1.1.88-1.67,1.29a3,3,0,0,0-.32.12l-.7-.62A13.43,13.43,0,0,0,368.37,550a10.7,10.7,0,0,0-10.49,5.63A19.53,19.53,0,0,0,348,553.8a4.85,4.85,0,0,0-2.06.5,4.25,4.25,0,0,0-1.55,1.73,7.86,7.86,0,0,0,0,7.13,10.91,10.91,0,0,0-7.88,8c-.46,2-.6,4.56.59,6.3a7.77,7.77,0,0,0-1.11,1.32,5.3,5.3,0,0,0-1,3.92c.37,2.15,2.57,3.43,4.52,3.84a2.22,2.22,0,0,0,.51.06,11.44,11.44,0,0,0-6.89,11c.3,5.42,4.19,10.21,9,12.57,2.54,1.24,6.11,1.65,7.74-.67a3.77,3.77,0,0,0-1-5.11c-.65-.42-1.4-.61-2.08-1A4.76,4.76,0,0,1,347,595c.93-.46,2-.59,3-1a6.64,6.64,0,0,0,4.15-6c0-1.62-.51-3.45.48-4.74s3.19-1.29,4.31-2.57c1.39-1.6.35-4.13.85-6.19a4.76,4.76,0,0,1,4.27-3.41,6.62,6.62,0,0,1,5.18,2.24,10.89,10.89,0,0,1,17,3c.74,1.39,1.21,3,2.34,4.06.59.55,1.31.93,1.88,1.49,1.76,1.72,1.63,4.68.53,6.88-.53,1.05-1.27,2.16-1,3.3.53,1.91,3.22,1.81,5,2.69,2.21,1.09,3,4.13,2.13,6.46a9.27,9.27,0,0,1-5.28,4.94,14.35,14.35,0,0,1,.33,6.67,12.42,12.42,0,0,0,12.39-5.26C407.15,603.53,406.53,597.6,402.88,594.54Zm-62.57-19.41h0l0,0S340.31,575.15,340.31,575.13Zm.85,11.09a.41.41,0,0,0,.11-.07,2.29,2.29,0,0,0,.57-.66c.13.18.25.37.39.55A9.18,9.18,0,0,0,341.16,586.22Z"
                fill="#8f493b"
              />
              <polygon
                points="350.53 595.64 351.01 596.18 351.86 596.44 352.29 596 351.58 594.96 350.53 595.64"
                fill="#8f493b"
              />
              <polygon
                points="389.98 596 390.44 596.44 391.06 596.29 391.73 595.48 390.68 594.96 389.98 596"
                fill="#8f493b"
              />
            </g>
            <path
              d="M378,559.29s-7.64.91-8.57,12.06"
              fill="none"
              stroke="#bf665a"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={0.5}
            />
            <path
              d="M390.94,609.83c-.55,3.83-3.51,8.45-6.29,11.06-1.4,1.31-2.61,2.42-2.45,4.49a4.21,4.21,0,0,0,3.39,3.8c7.26,1.89,20.94-6.08,14.46-14.24-1.15-1.44-3.78-1.26-4.95,0l-1.77,1.9,5.85,3.41a11.09,11.09,0,0,1,2.72-4.06c3.21-3.18-1.67-8-4.95-5a104.69,104.69,0,0,0-8.73,9.26c-2.86,3.44,2.06,8.42,4.95,5a104.69,104.69,0,0,1,8.73-9.26l-4.95-5a19.26,19.26,0,0,0-4.52,7.15c-1.23,3.31,3.56,5.87,5.85,3.4l1.77-1.9H395.1c-.61-.77-.18-.63-1.13.13a11.84,11.84,0,0,1-2.21,1.34,10.4,10.4,0,0,1-2.09.81c-1,.26-2.58-.19-1.49.73l1,2.48c-.55,1.11-.54,1.36,0,.77a7.2,7.2,0,0,0,.71-.64,18.64,18.64,0,0,0,1.58-1.74,27.62,27.62,0,0,0,2.64-3.88c1.37-2.42,3.13-5.41,3.53-8.2.63-4.4-6.11-6.31-6.75-1.86Z"
              fill="#8f493b"
            />
            <path
              d="M338.6,607.16c-4.67,3.2-4.06,9.7-.15,13.34,4.52,4.2,11.95,6.46,17.65,8.58,3.93,1.46,5.75-4.28,2.69-6.4-3.63-2.52-5.62-6.66-7.25-10.64-1.36-3.28-5.41-3.33-6.75,0a13.91,13.91,0,0,1-1.47,3.09l3-1.73c.8.25.8.14,0-.32l-1.73-1.34c-3.56-2.74-7.05,3.33-3.53,6,1.92,1.48,4,3.44,6.59,2.31,2.32-1,3-4.08,3.85-6.2h-6.75c2.4,5.83,5.17,11.15,10.47,14.82l2.7-6.39c-3.1-1.16-6.15-2.42-9.13-3.87-.85-.41-8.25-4.19-6.7-5.25,3.69-2.53.2-8.6-3.53-6.05Z"
              fill="#8f493b"
            />
          </g>
          <path
            d="M385.11,629.56c4.51,0,4.52-7,0-7s-4.51,7,0,7Z"
            fill="#8f493b"
          />
          <ellipse cx={363} cy={600} rx={1} ry={2} fill="#564444" />
          <ellipse cx={379} cy={600} rx={1} ry={2} fill="#564444" />
        </g>
        <circle cx={427.81} cy={191.81} r={0.94} fill="#26211d" />
        <circle cx={409.94} cy={191.81} r={0.94} fill="#26211d" />
        <path
          d="M160,375.44c.28-.75-.1-1.1-1.3-1.28a8.74,8.74,0,0,0-3.6.4c-2.34.8-3.35,2.94-2.7,2.53a10.05,10.05,0,0,1,4.45-1.43C158.2,375.46,159.83,376,160,375.44Z"
          fill="#a32b28"
        />
        <path
          d="M168.87,375.38c-.26-.74.09-1.1,1.21-1.31a7.94,7.94,0,0,1,3.37.31c1.79.56,2.77,2.65,2.29,2.37a8.52,8.52,0,0,0-3.93-1.23C170.56,375.35,169,375.89,168.87,375.38Z"
          fill="#a32b28"
        />
        <g>
          <path
            d="M167.08,397.3s1.42,3.12-2.58,3-7.75-4.69-7.75-4.69Z"
            fill="#9c5844"
          />
          <path
            d="M167.08,397.3s1.66-3.33-3.4-2.18a28,28,0,0,1-6.93.46S163.4,398.11,167.08,397.3Z"
            fill="#9c5844"
          />
        </g>
        <path
          d="M164.86,390.28h0c1-.07,3.11-.59,3.74-1.52a1,1,0,0,0,.15-.87c-.33-1-2.1-7.22-2.12-7.28a.36.36,0,0,0-.44-.25.37.37,0,0,0-.25.45c.07.25,1.79,6.27,2.12,7.3a.26.26,0,0,1-.05.25c-.39.57-2.07,1.13-3.21,1.21a.36.36,0,0,0-.33.38A.35.35,0,0,0,164.86,390.28Z"
          fill="#9c5844"
        />
        <circle cx={170.5} cy={381.5} r={1.5} fill="#26211d" />
        <path
          d="M154.42,383.72h0a2.74,2.74,0,0,1,2-1.55,2.92,2.92,0,0,1,2.4.3c.33.24.59-.33.26-.57a3.51,3.51,0,0,0-2.85-.37,3.25,3.25,0,0,0-2.37,1.85c-.15.38.38.72.52.34"
          fill="#26211d"
        />
      </g>
      <g id="light">
        <polyline
          points="467.54 1079 305.39 3 967 616 967 1080"
          opacity={0.15}
          fill="url(#linear-gradient)"
        />
      </g>
    </g>
  </svg>
)

export default SvgConsentOneBEnd
